module.exports = __webpack_public_path__ + "static/media/ke.8db0f5f9.svg";